import { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

function extractPlainTextFromQuill(html) {
    const container = document.createElement("div");
    container.innerHTML = html;

    const lines = [];

    container.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            lines.push(node.textContent);
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
            lines.push(node.textContent);
        }
    });

    return lines.join("\n").trim();
}

function decodeHtml(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

function Editor({ value = "", onChange }) {
    const editorRef = useRef(null);
    const quillRef = useRef(null);

    useEffect(() => {
        if (!editorRef.current) return;

        quillRef.current = new Quill(editorRef.current, {
            theme: "snow",
            modules: {
                toolbar: [
                    [{ font: [] }, { size: [] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ color: [] }, { background: [] }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }, { align: [] }],
                    ["link", "image", "video"],
                    ["clean"]
                ]
            }
        });

        if (value) {
            quillRef.current.setText(value)
        }

        quillRef.current.on("text-change", () => {
            const html = quillRef.current.root.innerHTML;
            const rawText = extractPlainTextFromQuill(html);
            const finalContent = decodeHtml(rawText);

            onChange?.(finalContent);
        });

        return () => {
            quillRef.current = null;
        };
    }, []);

    return <div ref={editorRef} />;
}

export default Editor;
